import Doublebox from './doublebox';
import Splashpage from './splashpage';

import LaunchDarkly from '@module/launchdarkly';
import { EXPERIMENT_FREE_ACCOUNT } from '@constant/experiments';

let component = Doublebox;

if (LaunchDarkly.getVariant(EXPERIMENT_FREE_ACCOUNT)) {
  component = Splashpage; // When we launch free accounts globally Nov 2019, this will become the only splashpage
}

export default component;
